export const handleConfirm = (pendingVariantUrl: string | null, closeDrawer: () => void): void => {
  if (pendingVariantUrl) {
    // HACK: https://tracker.yandex.ru/NAVI-5854
    // Переход по ссылке с refresh, чтобы подгружать Remote ProductsCarousel с новыми данными
    window.location.href = pendingVariantUrl;
  } else {
    closeDrawer();
  }
};
